import { useContext } from 'react';
import { Language } from '../providers/Language';


const useLanguage = () => {
	return useContext(Language);
};

export default useLanguage;